import React from 'react';
import { compose, mergeDeepRight, indexOf } from 'ramda';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';

import styleFile from './AvailAccordion.js';
import { AvailRoomDetail, NoAvailRoomDetail } from '../AvailRoomDetail';
import AvailAccordionHeader from './AvailAccordionHeader';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import actions from '../../../../store/actions';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import RichText from '@synergycms_core/components/generic/RichText';
import Button from '@synergycms_core/components/generic/Button';
import { checkSameProps } from '@synergycms_core/utils';
import { getRoomName } from '../../../../utils';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import {FIDELTOUR_CODE} from '@synergycms_app/store/customer/loyaltyActions';
import { AvailFilters } from '../../AvailFilters';
import { roomsSelectionIsComplete } from '../../../../store/avail/availUtils';
import { filterAvailSection } from '../../../../store/avail/availUtils';
import { AvailAlert } from '../../AvailAlert';
import { AvailContext } from './../availContext.jsx';



const parseRoomPreference = config => {
  const { segmentAvail, roomPreferencesRaw, roomRatesSelected } = config;
  const roomPreferencesRawToJs = roomPreferencesRaw.toJS();
  return segmentAvail.reduce((defaultPreferences, data) => {
    const roomId = data.get('room_id');
    const occupGroupId = data.get('occup_group_id');
    const serviceId = data.get('service_id') || 0;

    if (!defaultPreferences[roomId]) {
      defaultPreferences[roomId] = {};
    }

    if (!defaultPreferences[roomId][occupGroupId]) {
      defaultPreferences[roomId][occupGroupId] = {};
    }

    const selectedRoomRate = roomRatesSelected.find(
      rr =>
        rr.get('room_id') === roomId &&
        rr.get('occup_group_id') === occupGroupId &&
        rr.get('service_id') === (serviceId || null)
    );

    defaultPreferences[roomId][occupGroupId][serviceId] =
      selectedRoomRate && selectedRoomRate.has('preferences')
        ? selectedRoomRate.get('preferences').toJS()
        : roomPreferencesRawToJs;
    return defaultPreferences;
  }, {});
};

const AvailAccordion = class AvailAccordion extends React.Component {
  static displayName = 'AvailAccordion';
  static contextType = AvailContext;
  constructor(props) {
    super(props);
    this.noAvailRoomsRef = React.createRef();

    const { roomPreferencesRaw, segmentAvail } = props.config;
    this.state = {
      showSegment: true,
      segmentAvail: segmentAvail,
      roomPreferencesRaw: roomPreferencesRaw,
      roomPreferences: parseRoomPreference(this.props.config),
      showNoAvailRooms: false
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (checkSameProps(nextProps.config, prevState, ['roomPreferencesRaw', 'segmentAvail'])) {
      return {
        segmentAvail: nextProps.config.segmentAvail,
        roomPreferencesRaw: nextProps.config.roomPreferencesRaw,
        roomPreferences: parseRoomPreference(nextProps.config)
      };
    } else return null;
  }

  selectRoomRate = ({isSelected, roomRate, toggleModal = false, selection = false, fromSelectionAvail = false}) => e => {
    e && e.preventDefault();

    const { config } = this.props;
    const { loyaltyUser, loyalty } = config;
    const loyaltyType = loyalty?.get("code");
    const {loyaltyEnabled, existLoyaltyAvail} =this.context;

    if(existLoyaltyAvail && toggleModal) {
      toggleModal(true);
      return;
    }

    if(FIDELTOUR_CODE === loyaltyType && !loyaltyUser && toggleModal) {
      toggleModal(true);
      return;
    }

    const prevRoomRateSelected = config.roomRatesSelected.find(
      roomRateSelected => roomRateSelected.get('idx') === config.segment
    );

    if (prevRoomRateSelected.get('room_id')) {
      config.triggerEvent('del_room', prevRoomRateSelected.toJS());
    } else {
      config.triggerEvent('add_room', roomRate.toJS());
    }

    //if (!isSelected) {
    const roomId = roomRate.get('room_id');
    const occupGroupId = roomRate.get('occup_group_id');
    const serviceId = roomRate.get('service_id') || 0;

    const rateHasLoyaltyDiscount = (roomRate.get('discounts') || List())
      .some(discount => discount.get('is_loyalty') && discount.get('percent', 0) < 0);
  
    const isLoyaltyUserLogged = !!loyaltyUser?.get('user_id');
 
    let tier = (rateHasLoyaltyDiscount || isLoyaltyUserLogged) && loyaltyEnabled && (loyaltyUser?.getIn(['tier', 'current']) || loyalty?.getIn(["tier"]));
    const currentHasLoyalty = loyaltyEnabled === true;
    roomRate = roomRate.set("hasLoyalty", currentHasLoyalty);

    const otherRoomsHaveLoyalty = config.roomRatesSelected.some(rr =>
      rr.get("hasLoyalty") === true
    );

    if (currentHasLoyalty || otherRoomsHaveLoyalty) {
      config.loyalty = config.loyalty.set("active", true);
    }

    config.setReservationBlock(roomRate, this.state.roomPreferences[roomId][occupGroupId][serviceId], tier);

    const nextRoomRateSelected = config.roomRatesSelected.size > 0 && config.roomRatesSelected.find(
      roomRateSelected => 
        fromSelectionAvail ? 
          !roomRateSelected.has('room_id') && roomRateSelected.get('idx') !== config.segment : 
          roomRateSelected.get('idx') > config.segment && !roomRateSelected.has('room_id')
    );
    setTimeout(()=>config.setVisibleSegment((nextRoomRateSelected && nextRoomRateSelected.get('idx')) || null))
    
    
    if(!selection) {
      this.props.config.removeSectionFromSelection(this.props.config.segment,false);
    }
  };

  onEditSegment = e => {
    e.preventDefault();

    if (this.props.config.visibleSegment) {
      this.props.config.setVisibleSegment(false);
    } else {
      this.props.config.setVisibleSegment(this.props.config.segment);
    }
  };

  onDeleteSegmentClick = e => {
    e.preventDefault();
    this.props.config.onDeleteSegment(this.props.config.segment);
    this.props.config.removeSectionFromSelection(this.props.config.segment,true,true);
  };

  changeRoomsPreferences = (roomId, occupGroupId, serviceId, preferences) => {
    this.setState(state =>
      mergeDeepRight(state, {
        roomPreferences: {
          [roomId]: {
            [occupGroupId]: {
              [serviceId || 0]: preferences
            }
          }
        }
      })
    );
  };

  isMobile = () => {
    return this.props.theme.deviceType !== 'DESK';
  };

  scrollIntoView(ref) {
    const element = ref.current.getBoundingClientRect();
    setTimeout(() => {
      window.scrollTo({top: element.top + window.scrollY - 120, behavior: 'smooth'});
    }, 1);
  };

  toggleNoAvailRooms = e => {
    e.preventDefault();
    this.setState(state => ({
      showNoAvailRooms: !state.showNoAvailRooms
    }));
    !this.state.showNoAvailRooms && this.isMobile() && this.scrollIntoView(this.noAvailRoomsRef);
  };

  render() {
    const { config, theme } = this.props,
      {
        totalSegments,
        segment,
        isFirstSegment,
        roomRatesSelected,
        showTaxes,
        staticRooms,
        visibleSegment,
        params,
        roomsCustomOrder,
        selection,
        selectionAvail,
      } = config;    
    let { segmentAvail } = config;
    
    const filtered = selectionAvail && selectionAvail.get(segment-1) ? filterAvailSection(segmentAvail,selectionAvail.get(segment-1)) : segmentAvail;
    let filterSuccess = false;
    if(filtered?.get('filter_success') !== false) {
      segmentAvail = filtered;
      filterSuccess = true;
    }
    
    const adults = segmentAvail
      .valueSeq()
      .first()
      .get('adults');
    const childs = segmentAvail
      .valueSeq()
      .first()
      .get('childs');
    const babies = segmentAvail
      .valueSeq()
      .first()
      .get('babies');

      const childsInfo = segmentAvail
      .valueSeq()
      .first()
      .get('childs_info');
    const occupGroupID = segmentAvail
      .valueSeq()
      .first()
      .get('occup_group_id');
    const { classes } = theme.styles;
    let renderedRoomIndex = -1;
    const roomRateSelected = roomRatesSelected.size > 0 && roomRatesSelected.get(segment - 1, Map());
    const segmentFilled = roomRateSelected && roomRateSelected.has('room_id');
    const roomId = roomRateSelected.get('room_id');
    const serviceId = roomRateSelected.get('service_id');
    const roomAvail = segmentFilled && segmentAvail.get(serviceId ? roomId + '-' + serviceId : roomId);
    const boardSelected =
      segmentFilled &&
      segmentAvail.getIn([
        roomRateSelected.get('room_id'),
        'boards',
        roomRateSelected.get('board_id'),
        roomRateSelected.get('unique_ref_type'),
        'board_name'
      ]);
    const segmentAmount =
      segmentFilled && (showTaxes ? roomRateSelected.get('price_tax') : roomRateSelected.get('price'));
    const roomSection =
      roomAvail &&
      (
        staticRooms.find(
          r =>
            r.get('id') === roomAvail.get('room_id') &&
            r.get('occup_group_id') === roomAvail.get('occup_group_id') &&
            r.get('service_id') === roomAvail.get('service_id')
        ) ||
        staticRooms.find(
          r =>
            r.get('id') === roomAvail.get('room_id') &&
            r.get('occup_group_id') === r.get('default_occup_group_id') &&
            r.get('service_id') === roomAvail.get('service_id')
        )
      );


    const needAddOccupName = (roomSection && roomSection.get('occup_group_id') !== roomAvail.get('occup_group_id')) || childsInfo;
    let roomOccupName =  getRoomName({childsInfo, childs, babies, adults });


    let roomSelected = roomSection && !childsInfo ? roomSection.get('name') : roomAvail?.get?.('room_name');


    if (needAddOccupName) {
      roomSelected += roomOccupName;
    }

    const staticRoomsList = staticRooms.reduce((acc, room) => {
      roomsCustomOrder.forEach((row => {
        if(row.get('section_id') === room.get('section_id')) {
          room = room.set('weight', row.get('weight'));
        }
      }));
      return room.get('active') && !segmentAvail.get(room.get('id')) && !room.get('service_id') && room.get('occup_group_id') === occupGroupID ? acc.set(room.get('id'), room) : acc;
    }, Map()).sortBy(room => room.get('weight'));
    

    const roomSelectionComplete = segmentAvail && roomsSelectionIsComplete(segmentAvail) && params.get('selection_avail');

    if(roomSelectionComplete && !roomSelected) {

      const room = segmentAvail.first()
      const boards = room.get('boards')
      const uniqueRefsType = room.get('boards').first().keySeq().first()
      const board = boards.first().first()
      
      let [refType, rateId = null] = uniqueRefsType.split("-");
      rateId = rateId && parseInt(rateId, 0);

      const roomRate = Map({
        idx: segment,
        occup_group_id: room.get('occup_group_id'),
        adults: room.get('adults'),
        childs: room.get('childs'),
        babies: room.get('babies'),
        childs_info: room.get('childs_info'),
        room_id: room.get('room_id'),
        service_id: room.get('service_id'),
        board_id: board.get('board_id').toString(),
        refundable: board.get('refundable'),
        ref_type: refType,
        rate_id:rateId,
        unique_ref_type: uniqueRefsType.toString(),
        price: board.get('price'),
        price_tax: board.get('price_tax'),
        discount_amount: board.get('discount_amount') || null,
        discounts: board.get('discounts', List()),
        // Compatibilitat Hab + Paquet
        room_board_price: board.get('room_board_price', board.get('price')),
        room_board_price_tax: board.get('room_board_price_tax', board.get('price_tax')),
        service_price: board.get('service_price', 0),
        required_prepayment: board.get('required_prepayment', 0)
      });
      
      const allValuesDefined = roomRate.every(value => value !== undefined);
      if(allValuesDefined) this.selectRoomRate({isSelected:false,roomRate, selection:true, fromSelectionAvail:true})(null);
    }

    

    return (
      <div className={segmentFilled ? [theme.computedInnerStyle, classes.selected].join(' ') : theme.computedInnerStyle}>
        <AvailAccordionHeader
          segment={segment}
          totalSegments={totalSegments}
          adults={adults}
          childs={childs}
          babies={babies}
          childsInfo={childsInfo}
          segmentFilled={segmentFilled}
          roomSelected={roomSelected}
          boardSelected={boardSelected}
          segmentAmount={segmentAmount}
          onEditSegment={this.onEditSegment}
          onDeleteSegmentClick={this.onDeleteSegmentClick}
          activeSegment={visibleSegment && !segmentFilled}
          showHeader={roomSelectionComplete}
        />
        <div id="cmprm_123_rc_container" className={classes.priceCompare}></div>

        <ul className={(!roomSelectionComplete && totalSegments === 1) || visibleSegment ? classes.displayBlock : classes.hideEdit}>

          {filterSuccess ? (
            <AvailFilters avail={segmentAvail} segment={segment} />
          ) : (
            <AvailAlert type={'selection_avail'} showCalendar={false} showRelated={false}/>
          )}
          
          {segmentAvail.sort((a, b) => {
            if (a.get('room_id') === params.get('room_id')) {
              return -1;
            } else {
              return 0;
            }
          }).keySeq().map(roomId => {
            //console.log(roomId, indexOf("-", roomId) != -1);
            roomId = indexOf('-', roomId) !== -1 ? roomId : parseInt(roomId);

            const roomAvail = segmentAvail.get(roomId);
            // Si per algun casual (cosa que ja ha passat) no arribés el quota de la linia de dispo, ens saltarem el control de cupo
            let roomQuota = roomAvail.get('quota', false) || 99;
            roomRatesSelected.forEach(roomRateSel => {
              if (segment !== roomRateSel.get('idx') && roomId === roomRateSel.get('room_id')) {
                roomQuota--;
              }
            });

            let roomIdRaw = roomId;
            if (roomAvail.get('service_id')) {
              roomIdRaw = parseInt(roomId.split('-')[0], 10);
            }


            if (roomQuota <= 0) {
              return false;
            }
            renderedRoomIndex++;

            return (
              <li key={roomId} className={classes.listHabi}>
                <AvailRoomDetail
                  roomAvail={roomAvail}
                  roomId={roomIdRaw}
                  selectRoomRate={this.selectRoomRate}
                  segment={segment}
                  adults={adults}
                  childs={childs}
                  babies={babies}
                  childsInfo={childsInfo}
                  changeRoomsPreferences={this.changeRoomsPreferences}
                  roomPreferences={this.state.roomPreferences[roomIdRaw]}
                  isFirstImage={isFirstSegment && renderedRoomIndex === 0}
                />
              </li>
            );
          }).toArray()}
        </ul>
        {!selection && !selectionAvail && !!staticRoomsList.keySeq().size && !!visibleSegment && <div className={classes.noDispoButtonContainer}>
          <Button onClick={this.toggleNoAvailRooms} innerStyle={['toggleMainButtonReverse']}
                  ariaLabel={'_%Ver otras habitaciones sin disponibilidad%_'} translate={true}>
            {this.state.showNoAvailRooms ?
              <RichText
                text={'_%Ver otras habitaciones sin disponibilidad%_'}
                translate={true}
                ucFirst={true}
                innerStyle={['roboto14Gold']}
                rightIcon={{
                  unicodeContent: this.state.showNoAvailRooms && 'e001',
                  innerStyle: ['size12', classes.closeIcon, 'marginLeft14']
                }}
              /> :
              <RichText
                text={'_%Ver otras habitaciones sin disponibilidad%_'}
                translate={true}
                ucFirst={true}
                innerStyle={['roboto14Gold']}
              />
            }
          </Button>
        </div>}
        <ul className={classes.noAvailRoomContainer} ref={this.noAvailRoomsRef}>
          {this.state.showNoAvailRooms && staticRoomsList.keySeq().map(roomId => {
            //console.log(roomId, indexOf("-", roomId) != -1);
            roomId = indexOf('-', roomId) !== -1 ? roomId : parseInt(roomId);
            let roomIdRaw = roomId;
            return (
              <li key={roomId} className={classes.listHabi}>
                <NoAvailRoomDetail
                  room={staticRoomsList.get(roomId)}
                  selectRoomRate={this.selectRoomRate}
                  segment={segment}
                  adults={adults}
                  childs={childs}
                  changeRoomsPreferences={this.changeRoomsPreferences}
                  roomPreferences={this.state.roomPreferences[roomIdRaw]}
                />
              </li>
            );
          })}

        </ul>
      </div>
    );
  }
};

// GLOSARIO.md - FCL-001
const handleStepNavigation = (dispatch, ownProps, newBlock) => {
  const { customer, events, router } = actions;
  
  const hasAllRequiredSelectionParams = ownProps.selectionAvail && ownProps.selectionAvail?.every(subParam => {
    return ["room", "board", "type"].every(reqParam => subParam.has(reqParam));
  });

  const canSkipStep = ownProps.jumpSteps?.includes(ownProps.stepCode);

  if (!canSkipStep && ownProps.jumpSteps && ownProps.jumpSteps.size > 0) {
    dispatch(customer.step.jumpSteps.clear());
  }

  const skipStep = canSkipStep && hasAllRequiredSelectionParams;
  const isSingleSegment = ownProps.totalSegments === 1;
  const hasNoPreSelection = !ownProps.selectionAvail;
  const hasSingleSelectionWithSkip = ownProps.selectionAvail?.size <= 1 && skipStep;
  const isLastSegment = ownProps.totalSegments === newBlock.get('idx');
  
  const shouldProceedToNextStep = 
    (isSingleSegment && (hasNoPreSelection || hasSingleSelectionWithSkip)) ||
    (isLastSegment && skipStep);
  
  dispatch(customer.header.show('engine', false));
  
  if (shouldProceedToNextStep) {
    dispatch(customer.params.updateParams(Map({ selection_avail: null })));
    dispatch(customer.step.jumpSteps.remove(ownProps.stepCode));
    dispatch(events.trigger('next_step_1'));
    dispatch(customer.step.next());
    dispatch(router.update());
  }
};

const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    setReservationBlock: selectionAvailBlock => (newBlock, preferences, loyaltyTier = null) => {
      //if (selectionAvailBlock && !is(newBlock, immutablePick(selectionAvailBlock)(...newBlock.keySeq()))) {
      //  dispatch(actions.customer.params.updateParams(Map({ selection_avail: null })));
      //}
      const {customer} = actions;
      dispatch(customer.reservationRequest.set( (reservationRequest)=>{
        if(loyaltyTier) {
          return Map({ loyalty :(reservationRequest.get("loyalty", Map()) || Map()).mergeDeep(Map({selected : loyaltyTier})) });
        } else {
          return Map({"loyalty": null});
        }

        //return Map({loyalty:loyaltyTier ? Map({selected : loyaltyTier}) : null });
      }));
      dispatch(customer.reservationRequest.setBlock(newBlock, newBlock.get('idx')));
      dispatch(customer.reservationRequest.addRoomPreferences(newBlock.get('idx'), preferences));
      
      handleStepNavigation(dispatch, ownProps, newBlock);
    },
    onDeleteSegment: (params, selectionAvail) => (segment) => {
      const RoomRateSelected = ownProps.roomRatesSelected.find(
        roomRateSelected => roomRateSelected.get('idx') === segment
      );

      if (RoomRateSelected.get('room_id')) {
        dispatch(actions.events.trigger('del_room', { room: RoomRateSelected.toJS() }));
      }

      let newOccups = List();
      ownProps.roomRatesSelected.forEach((roomRate, key) => {
        if (roomRate.get('idx') !== segment) {
          newOccups = newOccups.push(params.getIn(['occups', key]));
        }
      });
      
      let newSelection = (selectionAvail && selectionAvail.filter((entry,key) => {
        return key !== segment-1
      })) || Map()

      if (newSelection.size === 0) {
        newSelection = null;
        ownProps.setVisibleSegment(1);
      }
      dispatch(actions.customer.params.updateParams(Map({ occups: newOccups, selection_avail: selectionAvail ? newSelection : null })));
      Promise.all([
        dispatch(actions.avail.getAvailAsync()),
      ]).then(() => {
        dispatch(actions.avail.getAvailParsed());
        dispatch(actions.customer.reservationRequest.initialize());
      });
      dispatch(actions.router.update(true));
    },
    removeSectionFromSelection: selection => (segment,update = true,resetOrder = false) => {
      if(!selection) return;
      var newSelection = selection.filter((entry, key) => key !== (segment - 1).toString())
      if(resetOrder) newSelection = newSelection.toList().toMap()
      
      dispatch(actions.customer.params.updateParams(Map({selection: newSelection})));
      if(update) dispatch(actions.router.update(true));
    },
    triggerEvent: (name, room) => {
      dispatch(actions.events.trigger(name, { room }));
    }
  };
};

const mapStateToProps = (store, ownProps) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);
  const hotelInfo = store.getIn(['hotels', hotelId]);
  const roomRatesSelected = store.getIn(['customer', 'reservation_request', 'blocks']);
  const selectionAvail = store.getIn(['customer', 'selection_avail'], null);
  const jumpSteps = store.getIn(['customer', 'step', 'jump_steps'], List());
  const stepCode = store.getIn(['customer', 'step', 'current_step', 'code'], null);

  const selectionAvailBlocks = selectionAvail && roomRatesSelected;

  const roomsCustomOrder = store.getIn(['hotels', hotelId, 'rooms_order'], List()).sortBy(b => b.get('weight'));
  return {
    roomRatesSelected: roomRatesSelected,
    params: hotelInfo.getIn(['params', 'params']),
    showTaxes: hotelInfo.get('show_taxes'),
    staticRooms: store.getIn(['hotels', hotelId, 'rooms']),
    roomsCustomOrder: roomsCustomOrder,
    roomPreferencesRaw: store.getIn(['customer', 'room_preferences']),
    loyaltyUser: store.getIn(['customer', 'loyalty','user'], null),
    loyalty: store.getIn(['customer', 'loyalty', 'data', 'loyalty'], null),
    selectionAvailBlock: (selectionAvailBlocks && selectionAvailBlocks.size && selectionAvailBlocks.get(ownProps.segment)) || null,
    selection: store.getIn(['customer', 'params','params','selection'],null),
    selectionAvail: selectionAvail,
    jumpSteps: jumpSteps,
    stepCode: stepCode,
  };
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, ownProps, stateProps, dispatchProps, {
    onDeleteSegment: dispatchProps.onDeleteSegment(stateProps.params,stateProps.selectionAvail),
    setReservationBlock: dispatchProps.setReservationBlock(stateProps.selectionAvailBlock),
    removeSectionFromSelection: dispatchProps.removeSectionFromSelection(stateProps.selection),
  });
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  ),
  PropertyManager([
    'setVisibleSegment',
    'visibleSegment',
    'segmentAvail',
    'totalSegments',
    'segment',
    'isFirstSegment',
    'setReservationBlock',
    'onDeleteSegment',
    'triggerEvent',
    'roomRatesSelected',
    'params',
    'showTaxes',
    'staticRooms',
    'roomsCustomOrder',
    'roomPreferencesRaw',
    'selectionAvail',
    'loyaltyUser',
    'loyalty',
    'selection',
    'removeSectionFromSelection',
    'stepCode',
    'jumpSteps'
  ]),
  withThemeJSS({ styleFile, index: 200, link: true }),
  withContent('i18n')
)(AvailAccordion);
